import { render, staticRenderFns } from "./RankingTabs.vue?vue&type=template&id=0d346f68"
import script from "./RankingTabs.vue?vue&type=script&lang=js"
export * from "./RankingTabs.vue?vue&type=script&lang=js"
import style0 from "./RankingTabs.vue?vue&type=style&index=0&id=0d346f68&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports